import ethers, { ContractInterface, Signer } from 'ethers';
import BaseContract from './BaseContract';

export abstract class Base20 extends BaseContract {
    constructor(contractAddress: string, abi: ContractInterface, signer: Signer | ethers.providers.Provider) {
        super(contractAddress, abi, signer);
    }

    async totalSupply(): Promise<number> {
        return await this.callFunction('totalSupply');
    }

    async balanceOf(owner: string): Promise<number> {
        return await this.callFunction('balanceOf', [owner]);
    }

    async allowance(owner: string, spender: string): Promise<number> {
        return await this.callFunction('allowance', [owner, spender]);
    }

    async transfer(to: string, value: number, options: ethers.PayableOverrides = {}): Promise<any> {
        return await this.callFunction('transfer', [to, value], options);
    }

    async approve(spender: string, value: number, options: ethers.PayableOverrides = {}): Promise<any> {
        return await this.callFunction('approve', [spender, value], options);
    }

    async transferFrom(from: string, to: string, value: number, options: ethers.PayableOverrides = {}): Promise<any> {
        return await this.callFunction('transferFrom', [from, to, value], options);
    }
}
